<app-material>
    <div class="header" header>
        <h2>{{ 'admin.roles.table.title' | translate }}</h2>
    </div>
    <ng-container body>
        <app-roles-table
            [roles]="roles"
            [tableConfig]="tableConfig"
            [isLoading]="isLoadingRoles"
            [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
            [hasTitle]="false"
            (sortChange)="onSortChange($event)"
            (filterChange)="onFilter($event)"
            (rowClick)="onTableRowClick($event)"
            (pageChange)="onPageChange($event)">
        </app-roles-table>
    </ng-container>
</app-material>


<app-roles-modal
    [role]="selectedRole"
    [permissions]="permissions"
    [internalPositions]="internalPositions"
    [shouldRenderModifiers]="shouldRenderModifiers()"
    [isLoading]="isLoadingRoles"
    (onUpdate)="update($event)">
</app-roles-modal>
